import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { authenticationService } from '../../_services';
import './userProfile.css';

class userProfile extends React.Component {
    render() {
        const v_email = authenticationService.currentUserValue.usuario.email;
        const v_name = authenticationService.currentUserValue.usuario.nombre;
        const v_group = authenticationService.currentUserValue.usuario.nomgrupo;
        const v_language = authenticationService.currentUserValue.usuario.descripcion;
        const v_token = authenticationService.currentUserValue.jwt_token;
        console.log(authenticationService);
        return (
            <Formik
                initialValues={{
                    name: v_name,
                    group: v_group,
                    language: v_language,
                    email: v_email,
                    password: '',
                    confirmPassword: ''
                }}
                validationSchema={Yup.object().shape({
                    name: Yup.string()
                        .required('Nombre requerido'),
                    group: Yup.string()
                        .required('Grupo requerido'),
                    language: Yup.string()
                        .required('Idioma requerido'),
                    email: Yup.string()
                        .email('Email invalido')
                        .required('Email requerido'),
                    password: Yup.string()
                        .min(6, 'Password debe tener por lo menos 6 caracteres')
                        .required('Password requerido'),
                    confirmPassword: Yup.string()
                        .oneOf([Yup.ref('password'), null], 'Passwords no coincide')
                        .required('Confirmación de Password requerida')
                })}
                onSubmit={fields => {
                    authenticationService.changePassword(v_token,fields.email,fields.password);
                    alert('SUCCESS!! :-)\n\n' + JSON.stringify(fields, null, 4))
                }}
                render={({ errors, status, touched }) => (
                    <Form>
                        <div className="form-group user">
                            <label htmlFor="email">Email:</label>
                            <Field name="email" type="text" className={'form-control user' + (errors.email && touched.email ? ' is-invalid' : '')} readOnly/>
                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group user">
                            <label htmlFor="name">Nombre:</label>
                            <Field name="name" type="text" className={'form-control user' + (errors.name && touched.name ? ' is-invalid' : '')} readOnly/>
                            <ErrorMessage name="name" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group user">
                            <label htmlFor="group">Grupo  :</label>
                            <Field name="group" type="text" className={'form-control user' + (errors.group && touched.group ? ' is-invalid' : '')} readOnly/>
                            <ErrorMessage name="group" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group user">
                            <label htmlFor="language">Idioma:</label>
                            <Field name="language" type="text" className={'form-control user' + (errors.language && touched.language ? ' is-invalid' : '')} readOnly/>
                            <ErrorMessage name="language" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group user">
                            <label htmlFor="password">Password:</label>
                            <Field name="password" type="password" className={'form-control user pass' + (errors.password && touched.password ? ' is-invalid' : '')} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group user">
                            <label htmlFor="confirmPassword">Confirmar:</label>
                            <Field name="confirmPassword" type="password" className={'form-control user pass' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                            <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group user">
                            <button type="submit" className="btn btn-primary mr-2">Cambiar Contraseña</button>
                            {/* <button type="reset" className="btn btn-secondary">Cambiar</button>  */}
                        </div>
                    </Form>
                )}
            />
        )
    }
}

export { userProfile }; 